
        // Disattiva e pulisci qualsiasi SW in DEV
        if ('serviceWorker' in navigator && import.meta.env.DEV) {
          (async () => {
            try {
              const regs = await navigator.serviceWorker.getRegistrations();
              for (const r of regs) await r.unregister();
              if (window.caches) {
                const keys = await caches.keys();
                for (const k of keys) await caches.delete(k);
              }
              // Evita che rimanga il controller attuale
              if (navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
              }
              console.log('[DEV] SW disattivato e cache pulita');
            } catch (e) {
              console.warn('[DEV] SW cleanup error', e);
            }
          })();
        }
      // Registra il Service Worker SOLO in produzione
      if ('serviceWorker' in navigator && import.meta.env.PROD) {
        window.addEventListener('load', async () => {
          try {
            const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
            console.log('SW registered:', registration);

            // Aggiornamenti SW
            registration.addEventListener('updatefound', () => {
              const newWorker = registration.installing;
              if (!newWorker) return;
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  if (confirm('Nuova versione disponibile! Vuoi aggiornare?')) {
                    window.location.reload();
                  }
                }
              });
            });
          } catch (error) {
            console.log('SW registration failed:', error);
          }
        });
      }

      // UI helpers (banner install + offline)
      const installBanner = document.getElementById('pwa-install-banner');
      const installBtn = document.getElementById('pwa-install-btn');
      const dismissBtn = document.getElementById('pwa-dismiss-btn');
      const offlineIndicator = document.getElementById('offline-indicator');

      // beforeinstallprompt
      let deferredPrompt;
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredPrompt = e;
        if (installBanner && !localStorage.getItem('pwa-install-dismissed')) {
          installBanner.style.display = 'block';
          installBanner.setAttribute('aria-hidden', 'false');
        }
      });

      installBtn?.addEventListener('click', async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);
        deferredPrompt = null;
        installBanner.style.display = 'none';
        installBanner.setAttribute('aria-hidden', 'true');
      });

      dismissBtn?.addEventListener('click', () => {
        if (!installBanner) return;
        installBanner.style.display = 'none';
        installBanner.setAttribute('aria-hidden', 'true');
        localStorage.setItem('pwa-install-dismissed', 'true');
      });

      window.addEventListener('appinstalled', () => {
        if (!installBanner) return;
        installBanner.style.display = 'none';
        installBanner.setAttribute('aria-hidden', 'true');
        console.log('PWA installed');
      });

      // Online/Offline
      const setOffline = (isOffline) => {
        if (!offlineIndicator) return;
        offlineIndicator.style.display = isOffline ? 'block' : 'none';
        offlineIndicator.setAttribute('aria-hidden', String(!isOffline));
      };
      window.addEventListener('online', () => setOffline(false));
      window.addEventListener('offline', () => setOffline(true));

      // URL Shortcuts -> localStorage (letto dall'app)
      const urlParams = new URLSearchParams(window.location.search);
      const action = urlParams.get('action');
      if (action) localStorage.setItem('pwa-shortcut-action', action);

      // Richiesta permessi Notifiche (mostra solo in produzione e se supportato)
      if ('Notification' in window && 'serviceWorker' in navigator && import.meta.env.PROD) {
        if (Notification.permission === 'default') {
          setTimeout(() => {
            if (confirm('Vuoi ricevere promemoria per tracciare il tuo umore?')) {
              Notification.requestPermission();
            }
          }, 5000);
        }
      }
    